export const MAZE_SIZE = 540;
export const PLAYER_SIZE = 12;
export const PLAYER_START = { left: 67, top: 6 };
export const PLAYER_SPEED = 200;
export const POINTS_PER_ITEM = 10;

export const MAZE_FINISH = {
  left: 474,
  top: 507,
  width: 70,
  height: 70,
};

export const MAZE_ITEMS = [
  {
    id: "coin4",
    leftPct: 30.8,
    topPct: 10.5,
    width: 24,
    height: 26,
    message:
      "You have collected Potato. Your journey starts with this versatile ingredient Potato",
  },
  {
    id: "coin5",
    leftPct: 59,
    topPct: 19.4,
    width: 30,
    height: 23,
    message: "You have collected Sago Pearls. This is the main ingredient",
  },
  {
    id: "coin2",
    leftPct: 84.1,
    topPct: 20,
    width: 40,
    height: 23,
    message: "You have collected Ghee. You have found the rich source of energy",
  },
  {
    id: "coin11",
    leftPct: 65,
    topPct: 33,
    width: 40,
    height: 23,
    message:
      "You have collected Green Chillies. Spices add the perfect kick to your recipe",
  },
  {
    id: "coin3",
    leftPct: 73.7,
    topPct: 50,
    width: 40,
    height: 23,
    message: "You have collected Groundnuts. It adds more flavor to the recipe",
  },
  {
    id: "coin1",
    leftPct: 69.7,
    topPct: 59,
    width: 35,
    height: 40,
    message:
      "You have collected coriander leaves. Adding coriander leaves gives a burst of flavor",
  },
  {
    id: "coin7",
    leftPct: 40.9,
    topPct: 62.9,
    width: 40,
    height: 28,
    message: "You have collected Stove. Saute the ingredients with the help of STOVE",
  },
  {
    id: "coin8",
    leftPct: 54.5,
    topPct: 75.9,
    width: 50,
    height: 23,
    message:
      "You have collected Water and lemon Juice. Adding water or Lemon Juice increases the flavor",
  },
  {
    id: "coin6",
    leftPct: 84.3,
    topPct: 84.4,
    width: 40,
    height: 23,
    message:
      "You have collected salt and sugar. Adding a pinch of sugar and some salt gives the final touch",
  },
];

export const MAZE_WALLS = [
  { left: 87, top: 35, width: 451, height: 3 },
  { left: 136, top: 35, width: 3, height: 25 },
  { left: 83, top: 58, width: 82, height: 3 },
  { left: 30, top: 36, width: 3, height: 26 },
  { left: 6, top: 35, width: 51, height: 3 },
  { left: 56.8, top: 58, width: 3, height: 120 },
  { left: 83.9, top: 82, width: 3, height: 24 },
  { left: 30, top: 128, width: 3, height: 140 },
  { left: 31, top: 105, width: 29.1, height: 3 },
  { left: 83, top: 129, width: 3, height: 70 },
  { left: 217, top: 175.1, width: 106, height: 3 },
  { left: 110, top: 131, width: 3, height: 93 },
  { left: 58, top: 128, width: 132, height: 3 },
  { left: 34, top: 198.3, width: 51, height: 3 },
  { left: 136.7, top: 153, width: 3, height: 47 },
  { left: 57, top: 222, width: 30, height: 3 },
  { left: 4, top: 34, width: 3, height: 470 },
  { left: 57.5, top: 224, width: 3, height: 47 },
  { left: 83.2, top: 225, width: 3, height: 92 },
  { left: 4, top: 268, width: 29, height: 3 },
  { left: 84, top: 268, width: 81, height: 3 },
  { left: 31, top: 292, width: 55, height: 3 },
  { left: 189, top: 176, width: 3, height: 46 },
  { left: 138, top: 221, width: 212, height: 3 },
  { left: 216, top: 175, width: 3, height: 25 },
  { left: 190, top: 151.8, width: 108, height: 3 },
  { left: 242, top: 82, width: 3, height: 25 },
  { left: 7, top: 81, width: 26, height: 3 },
  { left: 163.2, top: 129.3, width: 3, height: 71 },
  { left: 84, top: 82, width: 158, height: 3 },
  { left: 215.2, top: 106, width: 3, height: 24 },
  { left: 189, top: 58.3, width: 162, height: 3 },
  { left: 295, top: 61, width: 3, height: 22 },
  { left: 374.2, top: 38, width: 3, height: 68 },
  { left: 295, top: 81, width: 55, height: 3 },
  { left: 454, top: 36, width: 3, height: 23 },
  { left: 348, top: 81, width: 3, height: 25 },
  { left: 110, top: 105, width: 135, height: 3 },
  { left: 401, top: 58.3, width: 108, height: 3 },
  { left: 401, top: 82, width: 82, height: 3 },
  { left: 480, top: 60, width: 3, height: 24 },
  { left: 295, top: 128, width: 3, height: 26 },
  { left: 321, top: 151, width: 3, height: 27 },
  { left: 375, top: 128, width: 3, height: 27 },
  { left: 269, top: 104.1, width: 108, height: 3 },
  { left: 400.8, top: 151, width: 3, height: 26 },
  { left: 243, top: 198, width: 105, height: 3 },
  { left: 215, top: 128, width: 109, height: 3 },
  { left: 480.7, top: 106, width: 3, height: 26 },
  { left: 321, top: 151.6, width: 110, height: 3 },
  { left: 348.6, top: 198, width: 3, height: 72 },
  { left: 348, top: 175, width: 109, height: 3 },
  { left: 268.9, top: 178, width: 3, height: 23 },
  { left: 453.9, top: 128.1, width: 3, height: 47 },
  { left: 269, top: 246, width: 3, height: 26 },
  { left: 401, top: 198, width: 3, height: 26 },
  { left: 110, top: 245, width: 135, height: 3 },
  { left: 375, top: 223, width: 3, height: 25 },
  { left: 6, top: 315.8, width: 186, height: 3 },
  { left: 84, top: 339, width: 109, height: 3 },
  { left: 4, top: 338, width: 31, height: 3 },
  { left: 57, top: 319, width: 3, height: 23 },
  { left: 31, top: 362, width: 30, height: 3 },
  { left: 163, top: 248, width: 3, height: 23 },
  { left: 110, top: 362, width: 55, height: 3 },
  { left: 136, top: 385, width: 162, height: 3 },
  { left: 31, top: 365, width: 3, height: 93 },
  { left: 217, top: 315, width: 54, height: 3 },
  { left: 269, top: 245, width: 79, height: 3 },
  { left: 402, top: 104.8, width: 134, height: 3 },
  { left: 189.6, top: 247, width: 3, height: 47 },
  { left: 347.8, top: 128.2, width: 57, height: 3 },
  { left: 111, top: 270, width: 3, height: 24 },
  { left: 507, top: 81, width: 29, height: 3 },
  { left: 136, top: 292, width: 3, height: 26 },
  { left: 189, top: 362, width: 29, height: 3 },
  { left: 428, top: 128, width: 26, height: 3 },
  { left: 4, top: 503, width: 477, height: 3 },
  { left: 480, top: 175, width: 3, height: 26 },
  { left: 507, top: 128, width: 29, height: 3 },
  { left: 480, top: 152, width: 55, height: 3 },
  { left: 507, top: 176, width: 3, height: 49 },
  { left: 481, top: 175, width: 29, height: 3 },
  { left: 507, top: 245, width: 3, height: 50 },
  { left: 375, top: 199, width: 55, height: 3 },
  { left: 216, top: 268, width: 3, height: 26 },
  { left: 375, top: 222, width: 133, height: 3 },
  { left: 454, top: 198, width: 29, height: 3 },
  { left: 375, top: 245, width: 108, height: 3 },
  { left: 218, top: 268, width: 29, height: 3 },
  { left: 428, top: 248, width: 3, height: 47 },
  { left: 295.5, top: 268.8, width: 107, height: 3 },
  { left: 269, top: 291.2, width: 132, height: 3 },
  { left: 163, top: 292, width: 3, height: 25 },
  { left: 242, top: 293, width: 3, height: 25 },
  { left: 429, top: 268, width: 28, height: 3 },
  { left: 431, top: 292, width: 52, height: 3 },
  { left: 322, top: 315, width: 134, height: 3 },
  { left: 243, top: 339, width: 135, height: 3 },
  { left: 269, top: 293, width: 3, height: 25 },
  { left: 374, top: 270, width: 3, height: 24 },
  { left: 480, top: 270, width: 3, height: 47 },
  { left: 480, top: 315, width: 56, height: 3 },
  { left: 534, top: 37, width: 3, height: 467 },
  { left: 509, top: 268, width: 26, height: 3 },
  { left: 400, top: 339, width: 83, height: 3 },
  { left: 295, top: 294, width: 3, height: 47 },
  { left: 216, top: 315, width: 3, height: 72 },
  { left: 250, top: 363, width: 153, height: 3 },
  { left: 322, top: 363, width: 3, height: 48 },
  { left: 242, top: 409, width: 29, height: 3 },
  { left: 348, top: 364, width: 3, height: 70 },
  { left: 84, top: 408, width: 107, height: 3 },
  { left: 401, top: 342, width: 3, height: 45 },
  { left: 428, top: 362, width: 81, height: 3 },
  { left: 83.8, top: 339.5, width: 3, height: 48 },
  { left: 137, top: 341, width: 3, height: 22 },
  { left: 454, top: 363, width: 3, height: 23 },
  { left: 508, top: 339, width: 28, height: 3 },
  { left: 401, top: 385, width: 133, height: 3 },
  { left: 110.2, top: 363, width: 3, height: 25 },
  { left: 57, top: 384, width: 3, height: 50 },
  { left: 110, top: 433, width: 3, height: 70 },
  { left: 57, top: 432, width: 56, height: 3 },
  { left: 375, top: 409, width: 82, height: 3 },
  { left: 481, top: 409, width: 54, height: 3 },
  { left: 507, top: 410, width: 3, height: 25 },
  { left: 216, top: 432, width: 135, height: 3 },
  { left: 481, top: 456, width: 56, height: 3 },
  { left: 375, top: 363, width: 3, height: 48 },
  { left: 374, top: 432, width: 108, height: 3 },
  { left: 375, top: 455.6, width: 82, height: 3 },
  { left: 323, top: 479, width: 159, height: 3 },
  { left: 137, top: 411, width: 3, height: 71 },
  { left: 190, top: 455.2, width: 109, height: 3 },
  { left: 163, top: 362, width: 3, height: 25 },
  { left: 5, top: 479, width: 28, height: 3 },
  { left: 57, top: 455.8, width: 29, height: 3 },
  { left: 269, top: 387, width: 3, height: 25 },
  { left: 295, top: 387, width: 3, height: 24 },
  { left: 375, top: 435, width: 3, height: 23 },
  { left: 163, top: 479, width: 56, height: 3 },
  { left: 189, top: 388, width: 3, height: 70 },
  { left: 241, top: 479, width: 55, height: 3 },
  { left: 321, top: 455.1, width: 31, height: 3 },
  { left: 216, top: 408, width: 3, height: 25 },
  { left: 163, top: 411, width: 3, height: 70 },
  { left: 508, top: 502, width: 28, height: 3 },
  { left: 57, top: 479, width: 3, height: 26 },
  { left: 83, top: 456, width: 3, height: 49 },
  { left: 295, top: 458, width: 3, height: 46 },
  { left: 348, top: 457, width: 3, height: 24 },
  { left: 480, top: 432, width: 3, height: 27 },
  { left: 507, top: 479, width: 3, height: 26 },
];
